import { useState } from 'react'
import { ProjectInterface } from '../../../interfaces/ProjectInterface'
import { KeywordResponse } from '../../../types'

const CannibalizationModel = () => {
  const [ isLoading, setIsLoading ] = useState<Record<string, boolean>>({ search: false, export: false, projects: false, keywords: false });
  const [ projectsData, setProjectsData ] = useState<ProjectInterface>()
  const [ projectSelected, setProjectSelected ] = useState('')
  const [ keywordsData, setKeywordsData ] = useState<KeywordResponse>()

  // Pagination and Sorting in server side
  const[ filter, setFilter ] = useState(new Map())

  return {
    isLoading, setIsLoading,
    projectsData, setProjectsData,
    projectSelected, setProjectSelected,
    keywordsData, setKeywordsData,
    filter, setFilter
  }
}

export default CannibalizationModel

/*import { useState } from 'react';
import { ProjectInterface } from '../../../interfaces/ProjectInterface';
import { useProjectsData } from '../../../hooks/useProjectsData';
import useProjectsFilters from '../../../hooks/useProjectsFilters';
import useRangesDate from '../../../hooks/useRangesDate';
import useExportData from '../../../hooks/useExportData';

const CannibalizationModel = () => {

  const [project, setProject] = useState<ProjectInterface>({ property: null });
  const { dataProject, fetchCannibalization, loadingCannibalization } = useProjectsData();
  const [dataCannibalization, setDataCannibalization] = useState<any[]>([]);
  const { rangesDate, handleChangeRanges } = useRangesDate();
  const { fetchExportProjectsCannibalization, isLoading: isExportLoading } = useExportData();

  const {
    clicksOfSearches, hasClicksOfSearches, defaultValueClicks, handleClicksOfSearches,
    impressionsOfSearches, defaultValueImpression, hasImpressionsOfSearches, handleImpressionsOfSearches,
    positionOfSearches, hasPositionsOfSearches, defaultValuePositions, handlePositionOfSearches,
    ctrOfSearches, hasCtrOfSearches, defaultValueCtr, handleCtrOfSearches,
    handleFiltersApply
  } = useProjectsFilters();

  return {
    project, setProject,
    dataProject, fetchCannibalization, loadingCannibalization,
    dataCannibalization, setDataCannibalization,
    rangesDate, handleChangeRanges,
    clicksOfSearches, hasClicksOfSearches, defaultValueClicks, handleClicksOfSearches,
    impressionsOfSearches, defaultValueImpression, hasImpressionsOfSearches, handleImpressionsOfSearches,
    positionOfSearches, hasPositionsOfSearches, defaultValuePositions, handlePositionOfSearches,
    ctrOfSearches, hasCtrOfSearches, defaultValueCtr, handleCtrOfSearches,
    fetchExportProjectsCannibalization, isLoading: isExportLoading,
    handleFiltersApply
  }
}

export default CannibalizationModel

 */